import { Box, useBoolean } from '@chakra-ui/react';
import React from 'react';
import FileViewer from '../../../components/pdf_viewer/FileViewer';
import { SheetEyeIcon } from '../../../constants/IconData';
import { useAuditReportAttachment } from '../../../components/pdf_viewer/AuditReportViewer';

const AuditSheetFileViewer = ({ auditData, icon, chart_id=null }) => {
  const [isFileOpen, ifoState] = useBoolean(false);
  // Client-specific: chart_id may arrive as a non-string (e.g. number); temp fix until data is normalized upstream
  const isTocChart = typeof chart_id === 'string' && chart_id.startsWith('TOC');
  const { attachment } = useAuditReportAttachment({ chartId: isTocChart ? chart_id : undefined });
  return (
    <React.Fragment>
      {icon ? <Box onClick={ifoState.on}
        style={{
          width: 40,
          height: 40,
          cursor: 'pointer',
          display: 'inline-block',
        }}> {icon}</Box> : <SheetEyeIcon
        onClick={ifoState.on}
        style={{
          width: 40,
          height: 40,
          cursor: 'pointer',
          display: 'inline-block',
        }}
      />}
      <FileViewer
        isOpen={isFileOpen}
        currentFile={auditData?.file_obj}
        attachments={[
          ...(auditData?.attachments || []),
          ...(isTocChart && attachment ? [attachment] : [])
        ]}
        onClose={ifoState.off}
      />
    </React.Fragment>
  );
};

export default AuditSheetFileViewer;
